// Refine the getImage function to return the image alt and URL
export const getImage = (imgObj) => {
  const mapping = {
    original: "desktop",
    small: "mobile",
    thumbnail: "thumbnail",
  };

  const imageItem: { [key: string]: any } = {}; // Define the type here

  for (const [prop, key] of Object.entries(mapping)) {
    const href =
      imgObj?.data?.[prop]?.links?.site?.href ||
      imgObj?.[prop]?.links?.site?.href;
    if (href) {
      imageItem[key] = { url: href };
    }
  }

  imageItem.alt = imgObj?.data?.displayName || imgObj?.displayName;

  return imageItem;
};

const bloomreachGetters = {
  getImage
};

export default bloomreachGetters;
